<template>
  <div>
    <page-intro>
      <template v-slot:heading>Реквизиты</template>
      <template v-slot:info>
        <div class="mb-24">Управляйте вашими платежными лицами, выбирайте возможность заказа документов на почту или отправку по ЭДО</div>
        <a class="link icon-text-align" href="#">
          <span class="icon icon-primary mr-8" v-html="require('@/assets/img/icons/download.svg')" />
          Скачать договор
        </a>
      </template>
      <template v-slot:controls>
        <div class="mb-20">
          <el-button
            type="primary"
            class="w-100 mb-20"
            :disabled="!$store.state.user.accInfo.isAdmin"
            @click="handleCreateRequisite">
            Добавить платежное лицо
          </el-button>
          <instruction-link name="payments">Инструкция по платежам</instruction-link>
        </div>
      </template>
    </page-intro>
    <page-widget>
      <template v-slot:heading>
        Список ваших платежных лиц
      </template>
      <template v-slot:body>
        <div v-loading="$mip('getRequisites')">
          <non-data-stub :stub-data="requisites">
            <div v-for="(requisite, index) in requisites" :key="requisite.id">
              <div class="row flex-y-center">
                <div class="col-md-4">
                  <div class="h3">{{ requisite.orgName }}</div>
                  <div class="text-muted">{{ requisite.orgType }}</div>
                </div>
                <div class="col-md-3">
                  <div>ИНН: {{ requisite.inn }}</div>
                </div>
                <div class="col-md-4">
                  <div v-if="requisite.isPrimary" class="text-medium">Основное платежное лицо</div>
                </div>
                <div v-if="$store.state.user.accInfo.isAdmin" class="col-md-1">
                  <div class="edit-btn ml-auto" @click="handleEditRequisite(requisite)">
                    <span class="icon icon-sm" v-html="require('@/assets/img/icons/edit.svg')" />
                  </div>
                </div>
              </div>
              <div v-if="index !== requisites.length - 1" class="divider" />
            </div>
          </non-data-stub>
        </div>
      </template>
    </page-widget>

    <create-requisite-modal
      :visible.sync="createRequisiteModalOpened"
      :org-types="orgTypes"
      @update-list="getRequisites" />

    <edit-requisite-modal
      :requisite="editingRequisite"
      :visible.sync="editRequisiteModalOpened"
      :org-types="orgTypes"
      @update-list="getRequisites" />
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import PageWidget from '@/components/PageWidget.vue'
  import InstructionLink from '@/components/InstructionLink.vue'
  import CreateRequisiteModal from './CreateRequisiteModal.vue'
  import EditRequisiteModal from './EditRequisiteModal.vue'
  import NonDataStub from '@/components/stub/NonDataStub.vue'

  export default {
    components: {
      PageIntro,
      CreateRequisiteModal,
      EditRequisiteModal,
      PageWidget,
      InstructionLink,
      NonDataStub
    },

    data() {
      return {
        editRequisiteModalOpened: false,
        createRequisiteModalOpened: false,
        editingRequisite: {},
        requisites: [],
        orgTypes: []
      }
    },

    created() {
      this.getRequisites()
      this.getRequisiteModalsData()
    },

    methods: {
      handleEditRequisite(requisite) {
        this.editingRequisite = requisite
        this.editRequisiteModalOpened = true
      },

      handleCreateRequisite() {
        this.createRequisiteModalOpened = true
      },

      async getRequisites() {
        this.requisites = (await this.$http.getRequisites()).data
      },

      async getRequisiteModalsData() {
        this.orgTypes = (await this.$http.getRequisiteFormData()).data
      }
    }
  }
</script>